import config from '../config';

const fetch = require('isomorphic-fetch');

const baseURL = __CLIENT__ ? '/api' : config.apiPath;

export function upload(file, type, isPublic = false) {
  return fetch(`${baseURL}/files/upload/${type}?filename=${file.name}&public=${isPublic}`, {
    method: 'GET',
    credentials: 'include'
  })
    .then(res => res.json())
    .then((data) => {
      const formData = new FormData();
      Object.keys(data.params).forEach((key) => {
        formData.append(key, data.params[key]);
      });
      formData.append('file', file);
      return fetch(data.form_url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
        header: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => {
        if (res.ok) return Promise.resolve(data.params.key);
        return Promise.reject(res);
      });
    });
}

function encodeBase64UrlSafe(string) {
  let base64;
  if (typeof btoa !== 'undefined') {
    base64 = window.btoa(unescape(encodeURIComponent(string)));
  } else {
    base64 = Buffer.from(string).toString('base64');
  }
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

const presets = {
  thumbnail: { w: 400, h: 300, crop: 'fill', q: 80 },
  listingThumbnail: { w: 580, h: 580, crop: 'fill', q: 80 },
  profileAvatar: { w: 340, h: 340, crop: 'fill', q: 80 },
  reviewAvatar: { w: 100, h: 100, crop: 'fill', q: 80 },
  reviewAvatar2x: { w: 200, h: 200, crop: 'fill', q: 80 },
  profileCover: { w: 2600, h: 800, crop: 'fill' },
  tripCover: { w: 1200, h: 900, crop: 'fill' },
  tripCoverNew: { w: 1168, h: 656, crop: 'fill' },
  tripCoverIphone: { w: 1200, h: 900, crop: 'fill' },
  tripCoverMobile: { w: 600, h: 450, crop: 'fill' },
  avatarNavMini: { w: 74, h: 74, crop: 'fill' },
  avatarNavMini2x: { w: 148, h: 148, crop: 'fill' },
  avatarReviewCard: { w: 140, h: 140, crop: 'fill', q: 80 },
  avatarReviewCard2x: { w: 280, h: 280, crop: 'fill', q: 80 },
  coverTripCard: { w: 360, h: 360, crop: 'fill', q: 80 },
  coverTripCard2x: { w: 720, h: 720, crop: 'fill', q: 80 },
  avatarTripCard: { w: 46, h: 46, crop: 'fill' },
  avatarTripCard2x: { w: 92, h: 92, crop: 'fill' },
  featureCover: { w: 800, h: 370, crop: 'fill', q: 80 },
  featureCover2x: { w: 1600, h: 740, crop: 'fill', q: 80 },
  imageTopic: { w: 800, crop: 'fill', q: 80 },
  imageTopic2x: { w: 1600, crop: 'fill', q: 80 },
  inspCol1: { w: 660, h: 440, crop: 'fill', q: 80 },
  inspCol2: { w: 1320, h: 440, crop: 'fill', q: 80 },
  gallery: { w: 2560, q: 80, crop: 'auto' },
  reviewGallery: { w: 1200, h: 675, q: 80 },
  mobileGallery: { w: 1280, q: 80 },
  modalImage: { w: 500, h: 500, q: 80 },
  profileNoti: { w: 40, h: 40 },
  'square-300': { w: 600, h: 600, crop: 'fill', q: 80 },
  'square-230': { w: 230, h: 230, crop: 'fill', q: 80 },
  'square-460': { w: 460, h: 460, crop: 'fill', q: 80 },
  'rectangle-800-600': { w: 666, h: 500, crop: 'fill', q: 80 },
  'rectangle-600-600': { w: 600, h: 600, crop: 'fill', q: 80 },
  'rectangle-400-300': { w: 400, h: 300, crop: 'fill', q: 80 },
  'rectangle-300-400': { w: 300, h: 400, crop: 'fill', q: 80 },
  'rectangle-600-800': { w: 600, h: 800, crop: 'fill', q: 80 },
  'rectangle-310-233': { w: 310, h: 233, crop: 'fill', q: 80 },
  'rectangle-620-466': { w: 620, h: 466, crop: 'fill', q: 80 },
  tripCardLowRes: { w: 31, h: 23, crop: 'fill', q: 50 },
  lxCardCover: { w: 620, h: 300, crop: 'fill', q: 80 },
  lxCardAvatar: { w: 84, h: 84, crop: 'fill', q: 80 },
  lxCardAvatar2x: { w: 168, h: 168, crop: 'fill', q: 80 },
  imagesThumbnail: { w: 315, h: 220, crop: 'fill', q: 80 },
  imagesThumbnail2x: { w: 630, h: 440, crop: 'fill', q: 80 },
  similarTripCover: { w: 310, h: 200, crop: 'fill', q: 80 },
  similarTripAvatar: { w: 28, h: 28, crop: 'fill', q: 80 },
  lxAvatar: { w: 160, h: 160, crop: 'fill', q: 80 },
  lxAvatar2x: { w: 320, h: 320, crop: 'fill', q: 80 },
  articleCover: { w: 1200, h: 500, crop: 'fill', q: 80 },
  articleCoverMobile: { w: 800, h: 450, crop: 'fill', q: 80 },
  articleImage: { w: 800, h: 600, crop: 'fill', q: 80 },
  articleImage2x: { w: 1600, h: 1200, crop: 'fill', q: 80 },
  articleThumbnailCover: { w: 600, h: 300, crop: 'fill', q: 80 },
  fullSize: {},
  hd: { w: 1280, h: 720, crop: 'fill', q: 80 },
  masterGalleryCard: { w: 348, h: 435, crop: 'fill', q: 80 },
};

const convertPresetToImgproxy = (presetKey) => {
  const cfg = presets[presetKey];
  if (!cfg) return 'rs:fill:400:300/q:80'; // Default to thumbnail options if not found

  const {
    w = 0, h = 0, q, crop = 'auto',
  } = cfg;
  let options = `rs:${crop}:${w}:${h}`;
  if (q) options += `/q:${q}`;
  return options;
};

export function path(image, preset = 'thumbnail', style = false, noWatermark = false) {
  const options = convertPresetToImgproxy(preset);
  const s3Url = `s3://${config.s3Bucket}/${image}`;
  const base64Url = encodeBase64UrlSafe(s3Url);
  const url = `${config.mediaPath}/insecure/${options}/${base64Url}${noWatermark ? '?noMark=true' : ''}`;
  if (style) {
    return { backgroundImage: `url('${url}')` };
  }
  return url;
}

export function defaultAvatarImage(text, isRetina = false) {
  return `${config.uiKitAssetPath}/images/default/${(text || 'T')[0].toUpperCase()}${isRetina ? '@2x' : ''}.jpg`;
}
